export default {"src":"/_next/static/media/leave-logo.8de6136b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};